import "../styles/chooseUs.css";
import chooseImg from "../images/Car-Images/matel-demio.png";

// ✅ Import React Icons
import { FaHandshake, FaMoneyCheckAlt, FaCarAlt, FaUsers } from "react-icons/fa";
import { useEffect, useRef } from "react";

const WhyChooseUs = () => {

  const servicesRef = useRef (null);


  const reasons = [
    {
      id: "01",
      icon: <FaHandshake />,
      title: "Trusted Dealership",
      text: "With years of experience, we’ve built a reputation for honesty, reliability, and transparent car deals."
    },
    {
      id: "02",
      icon: <FaMoneyCheckAlt />,
      title: "Flexible Financing",
      text: "We assist clients with smooth car financing processes through trusted Kenyan banks and partners."
    },
    {
      id: "03",
      icon: <FaCarAlt />,
      title: "Wide Car Selection",
      text: "From compact cars to SUVs, we provide a wide range of quality vehicles to fit every lifestyle and budget."
    },
    {
      id: "04",
      icon: <FaUsers />,
      title: "Customer Satisfaction",
      text: "99% of our clients return for their next car or refer family and friends — proof of our commitment."
    }
  ];


      useEffect(() => {
      const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
  
      const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
          const elementIsInScreen =
            revealElements[i].getBoundingClientRect().top <
            window.innerHeight / 1.15;
  
          if (elementIsInScreen) {
            revealElements[i].classList.add("revealed");
          } else {
            revealElements[i].classList.remove("revealed");
          }
        }
      };
  
      window.addEventListener("scroll", scrollReveal);
      scrollReveal();
  
      return () => {
        window.removeEventListener("scroll", scrollReveal);
      };
    }, []);


  return (
    <div className="choose_us-wrapper" ref={servicesRef}>
      {/* LEFT */}
      <div className="choose__left-col">
        <div className="choose__us-content">
          <div data-reveal="left"> <span className="choose__tagline" >Why Choose Us</span></div>
          <h2 data-reveal>Matel Trading Motors – Your Trusted Car Dealership in Kenya</h2>
          <p data-reveal>
            At Matel Trading Ltd, we go beyond just selling cars. We focus on
            building trust, ensuring fair pricing, and offering car financing
            support to make the car ownership journey stress-free. Here’s why
            Kenyans choose us:
          </p>
        </div>

      <div className="choose__bottom-col" data-reveal="right">
        <img src={chooseImg} alt="choose us img" />
      </div>

      </div>
        <div className="choose__us-cards" data-reveal>
          {reasons.map((reason, index) => (
            <div className="choose__us-card" key={index} >
              <div className="choose__card-number" data-reveal="right">{reason.id}</div>
              <div className="choose__card-icon" data-reveal="left">{reason.icon}</div>
              <h4 data-reveal="left">{reason.title}</h4>
              <p data-reveal>{reason.text}</p>
            </div>
          ))}
        </div>
   

    </div>
  );
};

export default WhyChooseUs;
